/* Discount flags on product cards.

   The products grid and the search results are rendered in JavaScript from
   /products.json, and neither knows about Compare-at prices. This stamps a
   "15% off" flag onto any card whose product has one.

   TURNED OFF FOR LAUNCH, in one place: assets/gs-bits.css hides .gs-sale.
   Delete that one rule and flags come back everywhere at once — here and on
   the Liquid-rendered cards, which work their own flag out and are not
   touched by this file. Nothing here needs changing to bring them back.

   A ZERO PRICE IS NOT A 100% DISCOUNT. Every price on the site was set to
   zero for launch while the old Compare-at prices were left in place, so this
   file cheerfully worked out that GRANDPROOF PU 85 was down from AED 410 to
   nothing and stamped "100% off" across the catalogue. The guard below is the
   real fix and stays whatever the switch says: a product with no price has no
   discount, whatever the arithmetic comes to.

   One fetch of the catalogue, reduced to handle -> percent and cached in
   sessionStorage for half an hour, so it costs nothing after the first page.
   It re-runs on a MutationObserver because those grids re-render constantly. */

(function () {
  'use strict';

  var KEY = 'gs-sale-v2';
  var TTL = 30 * 60 * 1000;
  var CARDS = 'li.gs-prod, [data-gs-rgrid] > li, .gs-results__grid > li, .gs-hub li';

  var map = null;

  function cached() {
    try {
      var raw = window.sessionStorage.getItem(KEY);
      if (!raw) return null;
      var box = JSON.parse(raw);
      if (!box || Date.now() - box.at > TTL) return null;
      return box.map;
    } catch (err) {
      return null;
    }
  }

  function load() {
    map = cached();
    if (map) return Promise.resolve(map);

    return fetch('/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var out = {};
        ((data && data.products) || []).forEach(function (p) {
          var v = p.variants && p.variants[0];
          if (!v) return;

          var was = parseFloat(v.compare_at_price);
          var now = parseFloat(v.price);

          if (!isFinite(was) || !isFinite(now)) return;

          /* No price means no sale — see the note at the top. */
          if (now <= 0) return;
          if (was <= now) return;

          out[p.handle] = Math.round(((was - now) / was) * 100);
        });

        map = out;
        try {
          window.sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), map: out }));
        } catch (err) { /* private mode — just keep it in memory */ }
        return out;
      })
      .catch(function () {
        map = {};
        return map;
      });
  }

  function stamp() {
    if (!map) return;

    Array.prototype.forEach.call(document.querySelectorAll(CARDS), function (li) {
      if (li.querySelector('.gs-sale')) return;

      var link = li.querySelector('a[href*="/products/"]');
      if (!link) return;

      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;

      var off = map[m[1]];
      if (!off) return;

      if (window.getComputedStyle(li).position === 'static') li.style.position = 'relative';

      var flag = document.createElement('span');
      flag.className = 'gs-sale';
      flag.style.cssText = 'top:8px;left:8px;';
      flag.textContent = off + '% off';
      li.appendChild(flag);
    });
  }

  load().then(function () {
    stamp();

    var pending = null;
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        window.clearTimeout(pending);
        pending = window.setTimeout(stamp, 180);
      }).observe(document.body, { childList: true, subtree: true });
    }

    window.setTimeout(stamp, 1500);
  });
})();